import { useEffect, useRef, useState } from "react";
import MainHeading from "../../../../components/comman/MainHeading";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import AddHolidayModal from "./AddHolidayModal";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../../components/comman/MainFilterHandler";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import CommonTable from "../../../../components/comman/CommonTable";
import ConfirmModal from "../../../../components/comman/ConfirmModal";
import moment from "moment";
import { useSelector } from "react-redux";
import { checkUserAccess, getMonthStartEnd } from "../../../../utility/CommonFunctions";
import Calendar from 'react-calendar/dist/cjs/Calendar.js';
import EditIcon from "../../../../components/Icons/EditIcon";
import DeleteIcon from "../../../../components/Icons/DeleteIcon";

export default function Holiday() {
    const userDetails = useSelector((state) => state.root.userDetails);
    const [modal, setModal] = useState({
        updateData: false,
        deleteData: false
    });
    const [state, setState] = useState({
        leaveCount: null,
        holidayList: [],
        EditHolidaysData: null
    })
    const [selectedId, setSelectedId] = useState("");
    const [pageStates, setPageStates] = useState({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        tableLoader: false,
        filterData: "",
        searchQuery: "",
        startDate: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format("YYYY-MM-DD"),
        endDate: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format("YYYY-MM-DD"),
    });

    const [isLoading, setIsLoading] = useState(false)
    const toggleModal = (type) => {
        setModal((pre) => ({
            ...pre,
            ...(type === 'delete' ? { deleteData: !pre.deleteData } : { updateData: !pre.updateData }),
        }));
    }

    const getHoliday = (pageNo) => {
        let options = {
            method: "GET",
        };
        const Url = `${apiUrl.get_holiday}?` + MainFilterHandler(pageStates);
        setPageStates((pre) => ({
            ...pre,
            tableLoader: !pre.tableLoader
        }))
        callApi(Url, options).then((res) => {
            setPageStates((pre) => ({
                ...pre,
                tableLoader: !pre.tableLoader
            }));
            if (res?.status === true) {
                const newData = res?.data
                    ?.map((item) => ({
                        ...item,
                        dateOfHolidays: moment(item.holidayDate).format("DD/MM/YYYY"),
                    }));
                setState((pre) => ({
                    ...pre,
                    holidayList: newData,
                }));
                setPageStates((pre) => ({
                    ...pre,
                    count: res?.data?.pageInfo?.total,
                    totalPages: res?.data?.pageInfo?.totalPages,
                }))
            }
        })
    }

    const TableHeading = [
        { value: "dateOfHolidays", label: "Date of Holidays" },
        { value: "holidayName", label: "Holiday Name" },
        { value: "description", label: "Description" },
    ];

    const PageChangeHandler = (PageNo) => {
        // console.log("PageChangeHandler", PageNo);
        if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
            setPageStates((prev) => ({
                ...prev,
                currentPage: PageNo,
            }));
        }
    };

    const handleChangePageSize = (value) => {
        setPageStates((prev) => ({
            ...prev,
            pageSize: value,
            currentPage: 1
        }));
    };
    const handleEdit = (data) => {
        // if (isEndDateGreater(data?.endDate)) {
        setState((pre) => ({ ...pre, EditHolidaysData: data }));
        toggleModal();
        // } else {
        //     toast.error('Can not update past leave request.');
        // }
    }

    const ActionHandler = (data) => {
        setSelectedId(data?.id)
        toggleModal('delete');
    }

    const HandleDelete = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl.delete_holiday + `?holidayId=${selectedId}`;
        setIsLoading(true);
        callApi(API, options).then((response) => {
            setIsLoading(false);
            if (response?.status === true) {
                toast.success(response?.message);
                toggleModal('delete');
                getHoliday();
            } else {
                toast.error(response?.message);
                toggleModal('delete');
            }
        });
    };

    const ActionData = [
        {
            label: <i className="fas fa-edit" />,
            className: "btn btn-danger border-0 text-primary bg-primary-subtle py-2 m-1",
            icon: <EditIcon />,
            title: "edit",
            clickHandler: handleEdit,
        },
        {
            label: <i className="fas fa-trash-alt" />,
            className: "btn btn-success border-0 text-danger bg-danger-subtle py-2",
            icon: <DeleteIcon />,
            title: "delete",
            clickHandler: ActionHandler,
        }
    ];

    const handleMonthChange = ({ activeStartDate }) => {
        // console.log(activeStartDate);

        if (activeStartDate) {
            const startDate = getMonthStartEnd(activeStartDate).start.toDateString();
            const endDate = getMonthStartEnd(activeStartDate).end.toDateString();
            setPageStates((pre) => ({ ...pre, startDate: moment(startDate).format('YYYY-MM-DD'), endDate: moment(endDate).format('YYYY-MM-DD') }))
        }
    };

    const getTileClassName = (date, view, state) => {
        if (view !== 'month' || !state?.holidayList) return null;
        const checkDateInList = (dates, targetDate) =>
            dates.some(({ holidayDate }) => moment(targetDate).isSame(moment(holidayDate), 'day'));
        if (checkDateInList(state.holidayList, date)) return 'react-calendar__tile--holiday';
        return null;
    };

    useEffect(() => {
        getHoliday();
    }, [pageStates?.startDate, pageStates?.endDate, pageStates?.searchQuery, pageStates.pageSize])
    return (
        <>
            <div className="content">
                <MainHeading
                    title={"Holidays"}
                    buttonText={checkUserAccess(userDetails).isUserAccess && "Add Holidays"}
                    buttonIcon={checkUserAccess(userDetails).isUserAccess && <PlusIcon />}
                    // buttonLink={RoutesLink?.add_customer}
                    clickHandler={checkUserAccess(userDetails).isUserAccess && toggleModal}
                />
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 col-lg-4">
                                <Calendar className="table time-table"
                                    onActiveStartDateChange={handleMonthChange}
                                    tileDisabled={() => false} // Do not disable any days, enable all
                                    tileClassName={({ date, view }) => getTileClassName(date, view, state)}
                                />
                            </div>
                            <div className="col-12 col-lg-8">
                                <CommonTable
                                    TableHeading={TableHeading}
                                    TableData={state?.holidayList}
                                    ActionData={checkUserAccess(userDetails).isUserAccess ? ActionData : null}
                                    currentPage={pageStates?.currentPage}
                                    PageChangeHandler={PageChangeHandler}
                                    isLoading={pageStates?.tableLoader}
                                    totalPages={pageStates?.totalPages}
                                    count={pageStates?.count}
                                    handleChangePageSize={handleChangePageSize}
                                    pageSize={pageStates.pageSize}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddHolidayModal isOpen={modal.updateData} onClose={() => toggleModal()} EditHolidaysData={state?.EditHolidaysData} getHoliday={getHoliday} setState={setState} />
            <ConfirmModal
                modal={modal.deleteData}
                toggle={() => toggleModal('delete')}
                submitHandler={HandleDelete}
                isLoading={isLoading}
            />
        </>
    )
}
